import { useState, useEffect } from "react";

interface CountryResponse {
  ip: string;
  country: string;
}

interface UseCountryResult {
  country: string | null;
  loading: boolean;
  error: string | null;
}

export const useCountry = (): UseCountryResult => {
  const [country, setCountry] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCountry = async () => {
      try {
        const res = await fetch("https://api.country.is");

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        // 3. Cast the response to our interface
        const data = (await res.json()) as CountryResponse;

        setCountry(data.country);
      } catch (err) {
        // 4. Safely handle the 'unknown' type of err
        const message = err instanceof Error ? err.message : "Unknown error";
        setError(message);
      } finally {
        setLoading(false);
      }
    };

    fetchCountry();
  }, []);

  return { country, loading, error };
};
